import apiController from '@/utils/apiController';

export const TIPO_EVENTO_CADASTRO_PASSAGEIROS = 'CADASTRO_PESSOAS';

function nullableNumber(value) {
    if (value == null || value === '') return null;
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
}

function personName(person) {
    if (!person) return null;
    if (person.nome_completo) return String(person.nome_completo).trim();
    const name = [person.nome, person.sobrenome].filter(Boolean).join(' ').trim();
    return name || null;
}

export function normalizeHistoricoCadastroPessoa(person, extra = {}) {
    const source = person || {};
    return {
        id_pessoa: nullableNumber(source.id_pessoa),
        matricula: source.matricula || source.badge_meli || source.badge || null,
        nome_pessoa: personName(source),
        id_unidade: nullableNumber(source.id_unidade),
        cod_unidade: source.cod_unidade || null,
        id_turno: nullableNumber(source.id_turno),
        cod_turno: source.cod_turno || null,
        id_linha_ida: nullableNumber(source.id_linha_ida != null ? source.id_linha_ida : source.id_rota),
        cod_linha_ida: source.cod_linha_ida || null,
        id_linha_volta: nullableNumber(source.id_linha_volta),
        cod_linha_volta: source.cod_linha_volta || null,
        id_grupo: nullableNumber(source.id_grupo),
        cod_grupo: source.cod_grupo || null,
        resultado: extra.resultado || source.resultado || null,
        ...extra,
    };
}

/**
 * Registra uma operação do CRUD de passageiros em uma sessão própria do histórico.
 * A falha de auditoria não desfaz a operação funcional já concluída.
 */
export async function persistHistoricoCadastroPassageiros({
    idSessao,
    idUsuario,
    acao,
    titulo,
    pessoas,
    massivo = false,
    metadados = null,
} = {}) {
    try {
        const userId = Number(idUsuario);
        const session = idSessao != null ? String(idSessao).trim().slice(0, 36) : '';
        const normalizedPeople = (Array.isArray(pessoas) ? pessoas : [])
            .filter(Boolean)
            .map((person) => normalizeHistoricoCadastroPessoa(person));
        if (!Number.isFinite(userId) || userId <= 0) return { ok: false, reason: 'NO_USER' };
        if (!acao || !normalizedPeople.length) return { ok: false, reason: 'NO_EVENTS' };

        const unitIds = [...new Set(normalizedPeople
            .map((person) => person.id_unidade)
            .filter((id) => id != null))];
        const now = new Date().toISOString().slice(0, 19).replace('T', ' ');
        const payload = {
            id_usuario: userId,
            titulo: titulo || 'Cadastro de passageiros',
            tipo_evento: TIPO_EVENTO_CADASTRO_PASSAGEIROS,
            id_sessao: session || null,
            versao: null,
            id_unidade: unitIds.length === 1 ? unitIds[0] : null,
            id_cerca_destino: null,
            nome_destino: 'Cadastro de passageiros',
            id_modo_roteirizacao: 2,
            id_modo_frota: 1,
            id_sentido: 1,
            usa_base_inicial: 0,
            foi_clusterizado: 0,
            qtd_paradas: 0,
            qtd_rotas_operacionais: 0,
            qtd_rotas_total: 0,
            km_total: 0,
            passageiros_total: normalizedPeople.length,
            custo_total: 0,
            custo_mao_obra_total: 0,
            qtd_funcionarios: normalizedPeople.length,
            qtd_veiculos_fisicos: 0,
            dt_calculo: now,
            parametros_json: { origem: 'CRUD_PESSOAS' },
            paradas_json: [],
            rotas_json: [],
            resumo_rotas_json: [],
            paradas_por_rota_json: [],
            frota_json: [],
            custo_json: {},
            auxiliares_json: {},
            detalhe_json: {
                origem: 'CRUD_PESSOAS',
                acao: String(acao).toUpperCase(),
                massivo: !!massivo,
                quantidade: normalizedPeople.length,
                pessoas: normalizedPeople,
                metadados: metadados || null,
            },
        };
        const response = await apiController.request(
            apiController.endpoints.insertHistoricoroteirizacao,
            { data: payload, silent: true },
        );
        if (response && response.data && response.data.erro) {
            return { ok: false, reason: 'API_ERROR', mensagem: response.data.mensagem };
        }
        if (response && response.data && response.data.ignorado) {
            return {
                ok: false,
                skipped: true,
                reason: response.data.historicoAviso || 'NO_ROUTING_SESSION',
            };
        }
        return {
            ok: true,
            data: response && response.data,
            id_sessao: response && response.data && response.data.id_sessao,
        };
    } catch (error) {
        // O histórico é auditoria complementar: não bloqueia cadastro/baixa/autorização.
        console.warn('[historicoCadastroPassageiros] persist failed', error);
        return { ok: false, reason: 'EXCEPTION', error };
    }
}
